
      import Moon from './moon.vue'
      import type { App, Plugin } from 'vue'

      export const MoonPlugin: Plugin = {
        install(app: App) {
          app.component('Moon', Moon)
        },
      }
      export { Moon }
      